const initialValues = {
    full_name: "",
    email: "",
    fatherName: "",
    gender: "",
    martialStatus: "",
    phone_number: "",
    phone_number2: "",
    aadharNumber: "",
    PanNumber: "",
    company: "",
    dob: "",
    postal_code: "",
    street: "",
    geo_location: "",
    cust_type: "",
};

export const Gender = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" }
]

export const martial = [
    { value: "single", label: "Single" },
    { value: "married", label: "Married" },
    { value: "widowed", label: "Widowed" },
    { value: "divorced", label: "Divorced" }
]

export const validationRules = {
    full_name: {
        required: true,
        minLength: 3,
        message: {
            required: "Name is required.",
            minLength: "Name must be at least 3 characters long.",
        },
    },
    email: {
        required: true,
        pattern: /^\S+@\S+\.\S+$/,
        message: {
            required: "Email is required.",
            pattern: "Email is invalid.",
        },
    },
    age: {
        required: true,
        min: 1,
        message: {
            required: "Age is required.",
            min: "Age must be a positive number.",
        },
    },
    aadharNumber: {
        required: true,
        pattern: /^[0-9]{12}$/,
        message: {
            required: "Aadhaar number is required.",
            pattern: "Aadhaar number must be a 12-digit numeric value.",
        },
    },
    phone_number: {
        required: true,
        pattern: /^[6-9]\d{9}$/,
        message: {
            required: "Mobile number is required.",
            pattern: "Mobile number must be a 10-digit number starting with 6, 7, 8, or 9.",
        },
    },
    // phone_number2: {
    //     required: true,
    //     pattern: /^[6-9]\d{9}$/,
    //     message: {
    //         required: "Mobile number is required.",
    //         pattern: "Mobile number must be a 10-digit number starting with 6, 7, 8, or 9.",
    //     },
    // },
    fatherName: { required: true, message: "Father's name is required." },
    gender: { required: true, message: "Gender is required.", },
    martialStatus: { required: true, message: "Marital status is required." },
    PanNumber: {
        required: true,
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
        message:{
            required: "PAN number is required.",
            pattern: "PAN number must be in the format XXXXX9999X."},
    },
    company: { required: true, message: "Company name is required." },
    dob: { required: true, message: "Date of birth is required." },
    postal_code: {
        required: true,
        pattern: /^\d{6}$/,
        message: "Postal code must be a 6-digit number.",
    },
    street: { required: true, message: "Street address is required." },
    profile_pic: { required: true, message: "Profile image is required." },
    cust_type: { required: true, message: "Customer type is required." },
};

export const validateField = (field, value) => {
    const rules = validationRules[field];
    if (!rules) return "";

    if (rules.required && !value) {
        return rules?.message?.required || rules?.message;
    }

    if ((field === "gender" || field === "martialStatus") && rules.required) {
        const validOptions = field === "gender" ? Gender : field === "martialStatus" ? martial : [];
        const valid = validOptions.some((option) => option.value === value);
        return valid ? "" : "Invalid selection.";
    }
    if (rules.minLength && value.length < rules.minLength) {
        return rules.message.minLength;
    }
    if (rules.pattern && !rules.pattern.test(value)) {
        return rules.message.pattern;
    }
    if (rules.min && value < rules.min) {
        return rules.message.min;
    }

    return ""; // No error
};

  export const handleFormValidation = (form, setErrors) => {
      const newErrors = {};
      
      Array.from(form.elements).forEach((element) => {
        if (element.name) {   
          const error = validateField(element.name, element.value);
          if (error) {
            newErrors[element.name] = error;
          }
        }
      });
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // No errors
    };